var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67063 4.856C3.70733 4.90041 3.75644 4.93672 3.81372 4.96181C3.871 4.98689 3.93474 5 3.99946 5C4.06417 5 4.12791 4.98689 4.1852 4.96181C4.24248 4.93672 4.29158 4.90041 4.32828 4.856L7.92857 0.522966C7.97024 0.472988 7.99468 0.41445 7.99923 0.353712C8.00377 0.292975 7.98826 0.23236 7.95436 0.178454C7.92047 0.124548 7.86949 0.0794121 7.80697 0.0479508C7.74445 0.0164896 7.67278 -9.40999e-05 7.59974 1.74197e-06L0.399176 4.82984e-07C0.326308 0.000251256 0.2549 0.0170482 0.192632 0.0485847C0.130364 0.0801213 0.0795919 0.125204 0.0457757 0.178986C0.0119594 0.232767 -0.0036216 0.293212 0.000708313 0.35382C0.00503823 0.414428 0.0291152 0.472905 0.07035 0.522964L3.67063 4.856Z",
    fill: "#183254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrow);
export default __webpack_public_path__ + "static/media/downward_arrow.9d43f93d3ca56937bebe354f0a7e4d5a.svg";
export { ForwardRef as ReactComponent };